import * as React from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import {
  appointmentBookingImg,
  appointmentBookingImg1,
  appointmentBookingImg2,
  appointmentBookingImg3,
} from "./imports";
import "./appointmentBooking.css";

// * Complex button * //
const images = [
  {
    url: appointmentBookingImg1,
    title: <Link to="/appointmentProducts">DOG TOY</Link>,
    width: "30%",
  },
  {
    url: appointmentBookingImg2,
    title: <Link to="/appointmentProducts">DOG FOOD</Link>,
    width: "30%",
  },
  {
    url: appointmentBookingImg3,
    title: <Link to="/appointmentProducts">DOG CLOTHES</Link>,
    width: "30%",
  },
];

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: "relative",
  height: 500,
  [theme.breakpoints.down("sm")]: {
    width: "100% !important", // Overrides inline-style
    height: 400,
  },
  "&:hover, &.Mui-focusVisible": {
    zIndex: 1,
    "& .MuiImageBackdrop-root": {
      opacity: 0.15,
    },
    "& .MuiImageMarked-root": {
      opacity: 0,
    },
    "& .MuiTypography-root": {
      border: "4px solid currentColor",
    },
  },
}));

const ImageSrc = styled("span")({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundPosition: "center 40%",
});

const Image = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.common.white,
}));

const ImageBackdrop = styled("span")(({ theme }) => ({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.4,
  transition: theme.transitions.create("opacity"),
}));

const ImageMarked = styled("span")(({ theme }) => ({
  height: 3,
  width: 18,
  backgroundColor: theme.palette.common.white,
  position: "absolute",
  bottom: -2,
  left: "calc(50% - 9px)",
  transition: theme.transitions.create("opacity"),
}));

function AppointmentBanner() {
  return (
    <div className="illumin8__appointmentBanner">
      <div
        className="illumin8__appointmentBanner-Container"
        style={{
          backgroundImage: `url(${appointmentBookingImg})`,
        }}
      >
        <h1> HEALTH & BEAUTY </h1>
        <h3>Book a spa treatment with us</h3>
        <Link to="/appointmentPicker">
          <button> Book Now</button>
        </Link>
      </div>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          mt: 20,
          justifyContent: "center",
        }}
      >
        {images.map((image) => (
          <ImageButton
            focusRipple
            key={image.title}
            style={{
              width: image.width,
            }}
          >
            <ImageSrc style={{ backgroundImage: `url(${image.url})` }} />
            <ImageBackdrop className="MuiImageBackdrop-root" />
            <Image>
              <Typography
                component="span"
                variant="h4"
                color="inherit"
                sx={{
                  position: "relative",
                  p: 4,
                  pt: 2,
                  pb: (theme) => `calc(${theme.spacing(1)} + 6px)`,
                }}
              >
                {image.title}
                <ImageMarked className="MuiImageMarked-root" />
              </Typography>
            </Image>
          </ImageButton>
        ))}
      </Box>
    </div>
  );
}

export default AppointmentBanner;
